import tsag from '../assets/ministries/tsagcover.png';
import workshopcover from '../assets/ministries/workshopcover.png';
import streetmissioncover from '../assets/ministries/streetmissioncover.png';
import carolingcover from '../assets/ministries/carolingcover.png';
import musicnightcover from '../assets/ministries/musicnight/musicnight1.png';

import tsag1 from '../assets/ministries/tsag/tsag1.png';
import tsag2 from '../assets/ministries/tsag/tsag2.png';
import tsag3 from '../assets/ministries/tsag/tsag3.png';
import tsag4 from '../assets/ministries/tsag/tsag4.png';

import workshop1 from '../assets/ministries/workshop/workshop1.png';
import workshop2 from '../assets/ministries/workshop/workshop2.png';
import workshop3 from '../assets/ministries/workshop/workshop3.png';
import workshop4 from '../assets/ministries/workshop/workshop4.png';
import workshop5 from '../assets/ministries/workshop/workshop5.png';

import streetmission2 from '../assets/ministries/streetmission/streetmission2.png';
import streetmission3 from '../assets/ministries/streetmission/streetmission3.png';
import streetmission4 from '../assets/ministries/streetmission/streetmission4.png';
import streetmission5 from '../assets/ministries/streetmission/streetmission5.png';
import streetmission6 from '../assets/ministries/streetmission/streetmission6.png';
import streetmission7 from '../assets/ministries/streetmission/streetmission7.png';
import streetmission8 from '../assets/ministries/streetmission/streetmission8.png';

import caroling1 from '../assets/ministries/community_outreach/caroling1.png';
import caroling2 from '../assets/ministries/community_outreach/caroling2.png';
import caroling3 from '../assets/ministries/community_outreach/caroling3.png';
import caroling4 from '../assets/ministries/community_outreach/caroling4.png';
import outreach1 from '../assets/ministries/community_outreach/outreach1.png';
import outreach2 from '../assets/ministries/community_outreach/outreach2.png';
import outreach3 from '../assets/ministries/community_outreach/outreach3.png';
import outreach4 from '../assets/ministries/community_outreach/outreach4.png';

import musicnight1 from '../assets/ministries/musicnight/musicnight1.png';
import musicnight2 from '../assets/ministries/musicnight/musicnight2.png';
import musicnight3 from '../assets/ministries/musicnight/musicnight3.png';
import musicnight4 from '../assets/ministries/musicnight/musicnight4.png';
import musicnight5 from '../assets/ministries/musicnight/musicnight5.png';
import musicnight6 from '../assets/ministries/musicnight/musicnight6.png';
import convention1 from '../assets/ministries/conventions/convention1.png';
import convention2 from '../assets/ministries/conventions/convention2.png';
import convention3 from '../assets/ministries/conventions/convention3.png';
import convention4 from '../assets/ministries/conventions/convention4.png';

import bootcamp1 from '../assets/ministries/bootcamp/bootcamp1.png';
import bootcamp2 from '../assets/ministries/bootcamp/bootcamp2.png';
import bootcamp3 from '../assets/ministries/bootcamp/bootcamp3.png';
import bootcamp4 from '../assets/ministries/bootcamp/bootcamp4.png';

import indiaMission1 from '../assets/ministries/india_mission/bible-boxes.png';
import indiaMission2 from '../assets/ministries/india_mission/village-gathering.png';
import indiaMission3 from '../assets/ministries/india_mission/boys-with-bibles.png';
import indiaMission4 from '../assets/ministries/india_mission/boys-smiling.png';
import indiaMission5 from '../assets/ministries/india_mission/roadside-students.png';

export const DEFAULT_MINISTRIES = [
  {
    name: 'INDIA MISSION',
    image: tsag,
    description:
      'India Mission supports local churches, pastors, and families through prayer, practical help, and regular visits to different regions.',
    update: {
      title: 'Team in Chandigarh',
      body: 'Our team in Chandigarh is distributing Bibles in the villages.',
      images: [indiaMission1, indiaMission2, indiaMission3, indiaMission4, indiaMission5],
    },
    images: [indiaMission1, indiaMission2, indiaMission3, indiaMission4, indiaMission5, tsag1, tsag2, tsag3, tsag4],
  },
  {
    name: 'BOOTCAMP',
    image: workshopcover,
    description:
      'Bootcamp is a focused week of teaching, worship, and small-group sessions that helps people grow in faith and learn how to serve others.',
    images: [bootcamp1, bootcamp2, bootcamp3, bootcamp4, workshop1, workshop2, workshop3, workshop4, workshop5],
  },
  {
    name: 'STREET MISSION',
    image: streetmissioncover,
    description:
      'Street Mission takes teams into local streets and neighborhoods to share the hope of Christ, offer conversation, prayer, and simple practical care.',
    images: [streetmission6, streetmission7, streetmission8, streetmission2, streetmission3, streetmission4, streetmission5],
  },
  {
    name: 'COMMUNITY OUTREACH',
    image: carolingcover,
    description:
      'Community Outreach builds steady relationships with neighbors and families through seasonal events, home visits, and practical support.',
    images: [outreach1, outreach2, outreach3, outreach4, caroling1, caroling2, caroling3, caroling4],
  },
  {
    name: 'MUSIC NIGHT',
    image: musicnightcover,
    description:
      'Music Night is an open evening of worship, testimonies, and music where people can gather, invite friends, and enjoy Christ-centered songs together.',
    images: [musicnight1, musicnight2, musicnight3, musicnight4, musicnight5, musicnight6],
  },
  {
    name: 'CONVENTIONS',
    image: convention4,
    description:
      'Our conventions are special gatherings for worship, Bible teaching, and prayer, with guest speakers who encourage the church in faith and daily life.',
    images: [convention1, convention2, convention3, convention4],
    streams: [
      {
        speaker: 'Pr. Anil Kodithottam',
        links: [
          { url: 'https://youtube.com/live/Iwn0TieApA0', label: 'Day 1' },
          { url: 'https://youtube.com/live/Q7zM7Mhi-dU', label: 'Day 2' },
          { url: 'https://youtube.com/live/7ixUc4MnQgw', label: 'Day 3' },
        ],
      },
      {
        speaker: 'Pr. Suresh Babu',
        links: [
          { url: 'https://www.youtube.com/live/VKxlIuhWkZE?si=L6gzVPUWikZNBK6Z', label: 'Day 1' },
          { url: 'https://www.youtube.com/live/SqkHg61EpAY?si=43HbKV2wFGm8WMFU', label: 'Day 2' },
          { url: 'https://www.youtube.com/live/SqkHg61EpAY?si=hfPzGNdFOHP6ZSVw', label: 'Day 3' },
        ],
      },
      {
        speaker: 'Pr. P. C. Cherian',
        links: [
          { url: 'https://www.youtube.com/live/GAX09_hOSjY?si=_WAGuiY9NK1QOU56', label: 'Day 1' },
          { url: 'https://www.youtube.com/live/C0hxKY2MOpo?si=0MUt8wVsR_ueUPmk', label: 'Day 2' },
          { url: 'https://www.youtube.com/live/8SxVd-bm2PA?si=17JFPdWbfqfTTcbK', label: 'Day 3' },
        ],
      },
    ],
  },
];

export function resolveMinistry(ministry, index, getContent) {
  const storedImages = getContent(`ministries.${index}.images`, null);
  const storedStreams = getContent(`ministries.${index}.streams`, null);
  const baseImages = Array.isArray(storedImages) ? storedImages : ministry.images;
  const updateImages = Array.isArray(ministry.update?.images) ? ministry.update.images : [];
  const images = [
    ...updateImages.filter((img) => !baseImages.includes(img)),
    ...baseImages,
  ];

  return {
    ...ministry,
    name: getContent(`ministries.${index}.name`, ministry.name),
    image: getContent(`ministries.${index}.cover`, ministry.image),
    description: getContent(`ministries.${index}.description`, ministry.description),
    update: ministry.update
      ? {
          title: getContent(`ministries.${index}.update.title`, ministry.update.title || ''),
          body: getContent(`ministries.${index}.update.body`, ministry.update.body || ''),
          images: updateImages,
        }
      : null,
    images,
    streams: Array.isArray(storedStreams) ? storedStreams : ministry.streams,
  };
}
